import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function WODetails({ selectedWorkOrder, refreshFunc }) {
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  const [showUpdateModal, setShowUpdateModal] = useState(null);
  const [WODetails, setWODetails] = useState(null);

  const [paymentTermsList, setPaymentTermsList] = useState(null);
  const [salesPersonsList, setSalesPersonsList] = useState(null);
  const [usersList, setUsersList] = useState(null);
  const [shippingMethodsList, setShippingMethodsList] = useState(null);
  const [locationsList, setLocationsList] = useState(null);

  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };
  const loadingOff = () => {
    setLoading(false);
  };

  const getDate = (inputDate) => {
    const date = new Date(inputDate);
    return date.toISOString().slice(0, 10).replace("T", " ");
  };

  const handleUpdateWoDetails = async (e) => {
    e.preventDefault();
    try {
      loadingOn();
      let WODetailsData = {
        locationId: formData?.locationId,
        WODate: formData?.WODate,

        paymentTermsId: formData?.paymentTermsId,
        salesPersonId: formData?.salesPersonId,
        insideSalesPersonId: formData?.insideSalesPersonId || null,
        shipmentMethod: formData?.shipmentMethod,
        invoiceReady: Boolean(formData?.invoiceReady),
      };

      if (formData?.WoDueDate) {
        WODetailsData.WoDueDate = formData?.WoDueDate;
      }

      let apiData = {
        id: selectedWorkOrder?.id,
        data: WODetailsData,
      };
      const { data } = await API.patch("/work-orders", apiData, {
        headers: authHeader(),
      });

      if (data?.message?.type === "success") {
        await refreshFunc();
        loadingOff();
        setShowUpdateModal(false);
        return;
      }
      console.log(data);
      alert("something went wrong check logs");
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getWODetailsData = async () => {
    try {
      loadingOn();
      const { data } = await API.get("/work-order/drop-down-details", {
        headers: authHeader(),
      });
      if (data?.type === "success") {
        setPaymentTermsList(data?.result?.paymentTermsList);
        setSalesPersonsList(data?.result?.salesPersonsList);
        setUsersList(data?.result?.usersList);
        setShippingMethodsList(data?.result?.shipmentMethodsList);
        loadingOff();
      }
      const locRes = await API.get("/locations", { headers: authHeader() });
      if (Array.isArray(locRes?.data)) {
        setLocationsList(locRes.data);
      }
      return;
      console.log(data);

      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };
  // Format date to ISO Wednesday, December 17, 2025
  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    // The New Date object is created.
    const date = new Date(dateStr);

    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      // CRITICAL: Forces the formatting to use UTC time, preventing day-shifting.
      timeZone: "UTC",
    };

    // CRITICAL: Forces the formatting to use U.S. English (en-US) style and words globally.
    return date.toLocaleDateString("en-US", options);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    setWODetails({
      location: selectedWorkOrder?.location,
      WODate: selectedWorkOrder?.WODate,
      WoDueDate: selectedWorkOrder?.WoDueDate,
      salesPerson: selectedWorkOrder?.salesPerson,
      insideSalesPerson: selectedWorkOrder?.insideSalesPerson,
      taxRate: selectedWorkOrder?.taxrate,
      paymentTerm: selectedWorkOrder?.paymentTerm,
      shippingMethod: selectedWorkOrder?.shippingMethod,
      invoiceReady: Boolean(selectedWorkOrder?.invoiceReady),
    });
    setFormData({
      locationId: selectedWorkOrder?.locationId,
      WODate: getDate(selectedWorkOrder?.WODate),
      WoDueDate: selectedWorkOrder?.WoDueDate
        ? getDate(selectedWorkOrder?.WoDueDate)
        : "",
      salesPersonId: selectedWorkOrder?.salesPersonId,
      insideSalesPersonId: selectedWorkOrder?.insideSalesPersonId,
      paymentTermsId: selectedWorkOrder?.paymentTermsId,
      shipmentMethod: selectedWorkOrder?.shipmentMethod,
      invoiceReady: Boolean(selectedWorkOrder?.invoiceReady),
    });
  }, [selectedWorkOrder, showUpdateModal]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      getWODetailsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  if (!WODetails) return <Spinner />;
  return (
    <div className="bg-white shadow-lg w-50 px-3 pb-2 custom-border-radius-sm">
      {loading && <Spinner />}
      {/*   WO Info
       ********************************************* */}
      <div className="d-flex inline-block justify-content-between align-items-center">
        <h4 className="mb-0">WO Details</h4>
        <h4 className="mb-0">
          <button
            type="button"
            className="btn btn-info btn-sm"
            onClick={() => setShowUpdateModal(true)}
          >
            Edit
          </button>
        </h4>
      </div>
      <hr className="mt-0 mb-1 w-50" />
      {/* Inside Sales Person */}
      <div className="row">
        <div className="col-4 fw-bold">Inside Sales Person</div>
        <div className="col-8">
          {WODetails?.insideSalesPerson
            ? `${WODetails?.insideSalesPerson?.firstName || ""} ${
                WODetails?.insideSalesPerson?.lastName || ""
              }`.trim()
            : "---"}
        </div>
      </div>
      {/* Location */}
      <div className="row">
        <div className="col-4 fw-bold">Brand</div>
        <div className="col-8">{WODetails?.location?.name}</div>
      </div>
      {/* WO Date */}
      <div className="row">
        <div className="col-4 fw-bold">WO Date</div>
        <div className="col-8">{getDate(WODetails?.WODate)}</div>
      </div>
      {/* Created By */}
      <div className="row">
        <div className="col-4 fw-bold">Created By</div>
        <div className="col-8">{selectedWorkOrder?.createdBy}</div>
      </div>
      {/* WO Ship date */}
      <div className="row">
        <div className="col-4 fw-bold">Due date</div>
        <div className="col-8">
          {WODetails?.WoDueDate ? formatDate(WODetails?.WoDueDate) : "---"}
        </div>
      </div>
      {/* Tax Rate */}
      <div className="row">
        <div className="col-4 fw-bold">Tax Rate</div>
        <div className="col-8">{WODetails?.taxRate?.rate}</div>
      </div>
      {/* Payment Term */}
      <div className="row">
        <div className="col-4 fw-bold">Payment Term</div>
        <div className="col-8">{WODetails?.paymentTerm?.name}</div>
      </div>
      {/* Sales Person */}
      <div className="row">
        <div className="col-4 fw-bold">Sales Person</div>
        <div className="col-8">{WODetails?.salesPerson?.name}</div>
      </div>
      {/* Shipment Method */}
      <div className="row">
        <div className="col-4 fw-bold">Shipment Method</div>
        <div className="col-8">{WODetails?.shippingMethod?.name}</div>
      </div>
      <div className="row">
        <div className="col-4 fw-bold">Invoiced</div>
        <div className="col-8">
          {WODetails?.invoiceReady ? (
            <span className="px-2 py-0 h6 rounded-pill ms-1 text-white bg-success">
              Yes
            </span>
          ) : (
            <span className="px-2 py-0 h6 rounded-pill ms-1 text-white bg-secondary">
              No
            </span>
          )}
        </div>
      </div>

      {/*   Customer Select Modal
       ********************************************* */}
      <Modal
        size=""
        contentClassName="bg-transparent"
        show={showUpdateModal}
        onHide={() => setShowUpdateModal(false)}
      >
        <Modal.Body>
          <div
            className="bg-white shadow-lg px-3 pb-2 pt-2 mb-2 me-2"
            style={{ borderRadius: 20 }}
          >
            <div className="fw-bold fs-4 mt-3 d-flex justify-content-between">
              <div>WO Details</div>
            </div>
            <hr className="my-0 mb-2" />
            <form onSubmit={handleUpdateWoDetails} className=" p-1">
              <div className=" p-1">
                <div className="row mb-1">
                  <label className="col-5">Inside Sales Person</label>
                  <div className="col-7">
                    <select
                      value={formData?.insideSalesPersonId || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          insideSalesPersonId: e.target.value
                            ? parseInt(e.target.value)
                            : null,
                        })
                      }
                      className="form-select"
                    >
                      <option value={""}>None</option>
                      {usersList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {`${item.firstName || ""} ${
                            item.lastName || ""
                          }`.trim()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Brand</label>
                  <div className="col-7">
                    <select
                      value={formData?.locationId || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          locationId: parseInt(e.target.value),
                        })
                      }
                      className="form-select"
                    >
                      <option value={""}>None</option>
                      {locationsList?.map((loc) => (
                        <option key={loc.id} value={loc.id}>
                          {loc.locationName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">WO Date</label>
                  <div className="col-7">
                    <input
                      className="form-control flex-grow-1 mx-0"
                      placeholder="Enter address company"
                      value={formData?.WODate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          WODate: e.target.value,
                        })
                      }
                      type="date"
                    />
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Due date</label>
                  <div className="col-7">
                    <input
                      className="form-control flex-grow-1 mx-0"
                      placeholder="Enter address company"
                      type="date"
                      value={formData?.WoDueDate}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          WoDueDate: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Payment Term</label>
                  <div className="col-7">
                    <select
                      value={
                        formData?.paymentTermsId
                          ? formData?.paymentTermsId
                          : "None"
                      }
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          paymentTermsId: parseInt(e.target.value),
                        })
                      }
                      className="form-select"
                    >
                      <option value={"null"}>None</option>
                      {paymentTermsList?.map((term) => (
                        <option key={term.id} value={term.id}>
                          {term.termName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Sales Person</label>
                  <div className="col-7">
                    <select
                      value={
                        formData?.salesPersonId
                          ? formData?.salesPersonId
                          : "None"
                      }
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          salesPersonId: parseInt(e.target.value),
                        })
                      }
                      className="form-select"
                    >
                      <option value={"null"}>None</option>
                      {salesPersonsList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Shipment Method</label>
                  <div className="col-7">
                    <select
                      value={formData?.shipmentMethod || ""}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          shipmentMethod: parseInt(e.target.value),
                        })
                      }
                      className="form-select"
                    >
                      <option value={"null"}>None</option>
                      {shippingMethodsList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.shippingMethod}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="row mb-1">
                  <label className="col-5">Invoiced</label>
                  <div className="col-7 ">
                    <input
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          invoiceReady: e.target.checked,
                        }))
                      }
                      checked={Boolean(formData?.invoiceReady)}
                      type="checkbox"
                      id="modalInvoiceReady"
                      data-switch="success"
                    />
                    <label
                      htmlFor="modalInvoiceReady"
                      data-on-label="Yes"
                      data-off-label="No"
                    ></label>
                  </div>
                </div>
              </div>
              <div className="text-end mt-3">
                <button
                  onClick={() => {
                    setShowUpdateModal(false);
                  }}
                  type="button"
                  className="btn btn-secondary"
                >
                  Close
                </button>
                <button type="submit" className="btn btn-success ms-1">
                  Save
                </button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
